export default function() {
  return new Worker(__webpack_public_path__ + "static/js/worker.75e42d09.worker.js");
}
